import React from "react";
import { MinimalCase } from "@/src/types/Entities/MinimalCase";
import { Conversation } from "@/src/types/Entities/Messaging/Conversation";
import { getProductData } from "@/src/services/productService";
import { useNavigate } from "react-router";
import { getNewMessageLink } from "@/src/services/messagingService";
import { TiptapEditorProvider } from "@/src/components/Tiptap/TiptapEditorProvider";
import { useCurrentEditor, useEditorState } from "@tiptap/react";
import { FormProvider } from "@/src/provider/Form/FormProvider";
import { MessageCenterMessageReplyForm } from "./MessageCenterMessageReplyForm";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type MessageCenterMessageReplyProps = {
  product: MinimalCase;
  conversation: Conversation;
};

export default function MessageCenterMessageReply(props: MessageCenterMessageReplyProps) {
  return (
    <TiptapEditorProvider>
      <MessageCenterMessageReplyInner {...props} />
    </TiptapEditorProvider>
  );
}

function MessageCenterMessageReplyInner({ product, conversation }: MessageCenterMessageReplyProps) {
  const navigate = useNavigate();
  const { editor } = useCurrentEditor();
  const extendedMinimalCase = {
    ...product,
    "@id": getProductData(product.name, "apiUri") + "/" + product.id,
    isCustomerDataCompleted: true,
  };

  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => {
      if (!editor) {
        return null;
      }

      return {
        json: editor.getJSON(),
      };
    },
  });

  if (conversation.isClosed || !conversation.id) {
    return null;
  }

  const onSubmit = () => {
    navigate(getNewMessageLink(extendedMinimalCase.name, extendedMinimalCase.id, conversation.id), {
      state: {
        editor: editorState?.json,
      },
    });
  };

  const initialValues = {
    message: "",
  };

  return (
    <FormProvider initialValues={initialValues} submitAction={onSubmit}>
      <ContentBox headline={"Antwort verfassen"}>
        <MessageCenterMessageReplyForm />
      </ContentBox>
    </FormProvider>
  );
}
